import { actions } from 'react-redux-form';
import * as moment from 'moment-timezone';

import { createReducer } from '@common/redux-utils';
import { OptionsViewModel } from '@models/common.models';

import {
  AutoAuthoStatusUpdateActionType,
  GetTripReasonsFailureAction,
  GetTripReasonsStartAction,
  GetTripReasonsSuccessAction,
  ResetAction,
  SelectSwoTripStatusAction,
  SetDateAction,
  SetSetTripStatusFormDispatcherAction,
  SetTripStatusFailureAction,
  SetTripStatusSuccessAction,
  SetTripStatusStartAction
} from './status-update.actions';

// Defining the state of the page.
// Should be one per page.
// All properties should be readonly.
export interface AutoAuthoStatusUpdateState {
  appointmentDate: moment.Moment | null;
  estimatedCompletionDate?: moment.Moment;
  selectedSwoTripStatus?: number;
  setTripStatusFormDispatcher?: Function;
  tripReasons?: OptionsViewModel[];
  tripStatusUpdated: boolean;
}

// This is the initial state of the page
export const autoAuthoStatusUpdateInitialState: AutoAuthoStatusUpdateState = {
  appointmentDate: null,
  tripStatusUpdated: false
};

function handleGetTripReasonsFailure(
  state: AutoAuthoStatusUpdateState,
  action: GetTripReasonsFailureAction
): AutoAuthoStatusUpdateState {
  return {
    ...state
  };
}

function handleGetTripReasonsStart(
  state: AutoAuthoStatusUpdateState,
  action: GetTripReasonsStartAction
): AutoAuthoStatusUpdateState {
  return {
    ...state
  };
}

function handleGetTripReasonsSuccess(
  state: AutoAuthoStatusUpdateState,
  action: GetTripReasonsSuccessAction
): AutoAuthoStatusUpdateState {
  return {
    ...state,
    tripReasons: action.reasons.sort((a, b) => (a.value < b.value ? -1 : a.value > b.value ? 1 : 0))
  };
}

function handleReset(state: AutoAuthoStatusUpdateState, action: ResetAction): AutoAuthoStatusUpdateState {
  if (state.setTripStatusFormDispatcher) {
    state.setTripStatusFormDispatcher(actions.reset('local'));
  }
  return {
    ...state,
    appointmentDate: null,
    selectedSwoTripStatus: undefined,
    tripStatusUpdated: false
  };
}

function handleSelectSwoTripStatus(
  state: AutoAuthoStatusUpdateState,
  action: SelectSwoTripStatusAction
): AutoAuthoStatusUpdateState {
  return {
    ...state,
    selectedSwoTripStatus: action.status
  };
}

function handleSetDate(state: AutoAuthoStatusUpdateState, action: SetDateAction): AutoAuthoStatusUpdateState {
  return {
    ...state,
    appointmentDate: action.date
  };
}

function handleSetSetTripStatusDispatcher(
  state: AutoAuthoStatusUpdateState,
  action: SetSetTripStatusFormDispatcherAction
): AutoAuthoStatusUpdateState {
  return {
    ...state,
    setTripStatusFormDispatcher: action.dispatcher
  };
}

function handleSetTripStatusFailure(
  state: AutoAuthoStatusUpdateState,
  action: SetTripStatusFailureAction
): AutoAuthoStatusUpdateState {
  return state;
}

function handleSetTripStatusStart(
  state: AutoAuthoStatusUpdateState,
  action: SetTripStatusStartAction
): AutoAuthoStatusUpdateState {
  return state;
}

function handleSetTripStatusSuccess(
  state: AutoAuthoStatusUpdateState,
  action: SetTripStatusSuccessAction
): AutoAuthoStatusUpdateState {
  if (state.setTripStatusFormDispatcher) {
    state.setTripStatusFormDispatcher(actions.reset('local'));
    state.setTripStatusFormDispatcher(actions.change('local.tripStatus', ''));
  }
  return {
    ...state,
    appointmentDate: null,
    selectedSwoTripStatus: undefined,
    tripStatusUpdated: true
  };
}

// This creates the reducer as redux wants it w/ a helper function
// There should an entry for each action type
export const AutoAuthoStatusUpdateReducer = createReducer(autoAuthoStatusUpdateInitialState, {
  [AutoAuthoStatusUpdateActionType.GetTripReasonsFailure]: handleGetTripReasonsFailure,
  [AutoAuthoStatusUpdateActionType.GetTripReasonsStart]: handleGetTripReasonsStart,
  [AutoAuthoStatusUpdateActionType.GetTripReasonsSuccess]: handleGetTripReasonsSuccess,
  [AutoAuthoStatusUpdateActionType.Reset]: handleReset,
  [AutoAuthoStatusUpdateActionType.SelectSwoTripStatus]: handleSelectSwoTripStatus,
  [AutoAuthoStatusUpdateActionType.SetDate]: handleSetDate,
  [AutoAuthoStatusUpdateActionType.SetSetTripStatusFormDispatcher]: handleSetSetTripStatusDispatcher,
  [AutoAuthoStatusUpdateActionType.SetTripStatusFailure]: handleSetTripStatusFailure,
  [AutoAuthoStatusUpdateActionType.SetTripStatusStart]: handleSetTripStatusStart,
  [AutoAuthoStatusUpdateActionType.SetTripStatusSuccess]: handleSetTripStatusSuccess
});



// WEBPACK FOOTER //
// ./src/auto-autho/_components/status-update/status-update.reducer.ts